import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AwardsReportReducer } from '../reducers';

export const selectAwardsReportFeature = createFeatureSelector<AwardsReportReducer.AwardsReportState>(AwardsReportReducer.featureName);

export const selectAwardsReport = createSelector(selectAwardsReportFeature, (state: AwardsReportReducer.AwardsReportState) => state.item);
